const CommentSentEvent = new CustomEvent('comment-sent-event', {
    cancelable: true,
    bubbles: true,
    detail: {},
    composed: false
});
export default CommentSentEvent;
